export default __webpack_public_path__ + "static/media/undraw_profile_2.9620ba4c.svg";